import { render, staticRenderFns } from "./questionStartInstructions.vue?vue&type=template&id=93f67944&scoped=true&"
import script from "./questionStartInstructions.vue?vue&type=script&lang=js&"
export * from "./questionStartInstructions.vue?vue&type=script&lang=js&"
import style0 from "./questionStartInstructions.vue?vue&type=style&index=0&id=93f67944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f67944",
  null
  
)

export default component.exports